import {HOME_PAGE_ARENA} from "../services/arenas/arena-consts";

export const SEO_CATEGORIES = {
  HOME: HOME_PAGE_ARENA,
  AI_GAMES_RECOMMENDATIONS: 'AI_GamesDisplayed',
  AI_NEW_GAMES_RECOMMENDATIONS: 'AI_NewGamesDisplayed'
};

